import styles from "./Admin.module.css";
import { NewUserProfileType } from "../Types/userProfile";

import React, { ChangeEvent, useEffect, useState } from "react";
import {
  DocumentData,
  QueryDocumentSnapshot,
  QuerySnapshot,
  collection,
  doc,
  getDoc,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { app } from "../lib/firebase";
import { NewProjectProfileType } from "../Types/projectProfile";
import {
  IteratedDataSnapshot,
  child,
  get,
  getDatabase,
  push,
  ref,
} from "firebase/database";
import AdminProfile from "./AdminProfile";
import { NewGroupProfileType } from "../Types/groupProfile";

const db = getFirestore(app);
const tempUser = localStorage.getItem("userUID");
let projectNo = 1;
let projectArray: any[] = [];

//console.log("projectArray = ", projectArray);

console.log("in AdminInfo and user id = ", tempUser);

function AdminInformation() {
  //let selectUsers = "var(${getSelectUsers()})";
  //const getSelectUsers = () => {
  //  return "--select-users";
  //};

  let groupSelected = false;

  //document.documentElement.style.setProperty('--${select-users}', "none");
  //let selectUsers = "none";
  const [selectUsers, setSelectUsers] = useState("none");
  const [selectSubgroups, setSelectSubgroups] = useState("none");
  const [selectProjects, setSelectProjects] = useState("none");
  //Groups
  const [groupProfiles, setGroupProfiles] = useState<NewGroupProfileType[]>([]);
  const [groupTitleInput, setGroupTitleInput] = useState("");
  const [groupDescriptionInput, setGroupDescriptionInput] = useState("");
  const [groupDetailedDescriptionInput, setGroupDetailedDescriptionInput] =
    useState("");
  const [groupSaveButton, setGroupSaveButton] = useState("");
  const [groupCreateButton, setGroupCreateButton] = useState("");
  const [groupDeleteButton, setGroupDeleteButton] = useState("");

  let groupRefArray: string[] = [];
  let groupTitles: string[] = [];
  let groupDescriptions: string[] = [];
  let groupDetailedDescriptions: string[] = [];
  let tempGroup: NewGroupProfileType;
  let groupTitlesIndex = 1;

  const GroupSelected = (e: ChangeEvent<HTMLSelectElement>) => {
    groupTitlesIndex = parseInt(e.target.value);
    console.log(" project selected is ", groupTitlesIndex);
    setGroupTitleInput(groupTitles[groupTitlesIndex]);
    //It makes sense to set up the groupTitles array so that we can do a fetch
    //and retrieve the document from its (group) name or by its reference if we
    //indeed save the reference at the time we do the initial query. Then we
    //can retrieve the document fields of description and detailed description.
    //This same logic can be duplicated for subgroups and projects
    console.log(" project selected is ", groupTitlesIndex);
    setGroupDescriptionInput(groupDescriptions[groupTitlesIndex]);
    setGroupDetailedDescriptionInput(
      groupDetailedDescriptions[groupTitlesIndex]
    );
    //setSelectUsers("show");
    //setSelectSubgroups("show");
    //setSelectProjects("show");
    groupSelected = true;
  };

  //const groupSelect = () => {
  const q0 = query(
    collection(db, "Groups"),
    where("title", "!=", ""),
    orderBy("title")
  );
  useEffect(
    () =>
      onSnapshot(q0, (snapshot) => {
        setGroupProfiles(
          snapshot.docs.map((doc) => {
            //console.log(" adminInfo 1 doc id = ", doc.id);
            //console.log(" adminInfo 2 projectProfiles = ", projectProfiles);
            tempGroup = groupProfiles;

            if (doc.id) {
              console.log(" Admin got a doc id from onSnapshot for groups! ");
              groupRefArray.push(doc.id);
              console.log(" docRefArray [0] ", groupRefArray[0]);
              console.log(" doc data () ", doc.data());
            }
            return {
              id: doc.id,
              ...doc.data(),
            };
            //return {};
          })
        );
      }),
    []
  );

  //The following produces a document snapshot
  //getDoc(doc(getFirestore(), "projectProfiles", "projectTitle")).then(
  //  (projectTitle) => {
  //    console.log("adminInfo projectTitle = ", projectTitle);
  //  }
  //);
  console.log(" before if groupProfiles and tempGroup = ", tempGroup);
  if (groupProfiles) {
    //The array of full objects with id as the key
    console.log(" adminInfo projectProfiles = ", groupProfiles);
    //What we'd like to do here is to create a new array consisting of just
    //The project titles (projectTitle) and that array will provide for the list box
    for (let i = 0; i < groupProfiles.length; i++) {
      groupTitles[i] = groupProfiles[i].title;
      groupDescriptions[i] = groupProfiles[i].description;
      groupDetailedDescriptions[i] = groupProfiles[i].detailedDescription;
      //console.log("project titles array [0] = ", description);
    }
  }
  //This is simply an array of doc ids - different from a reference
  if (groupRefArray) {
    //The array of doc ids
    console.log(" group array ids [0] = ", groupRefArray[0]);
  }

  //Subgroups
  const [subgroupProfiles, setSubgroupProfiles] = useState<
    NewGroupProfileType[]
  >([]);

  const [subgroupTitleInput, setSubgroupTitleInput] = useState("");
  const [subgroupDescriptionInput, setSubgroupDescriptionInput] = useState("");
  const [
    subgroupDetailedDescriptionInput,
    setSubgroupDetailedDescriptionInput,
  ] = useState("");
  const [subgroupSaveButton, setSubgroupSaveButton] = useState("");
  const [subgroupCreateButton, setSubgroupCreateButton] = useState("");
  const [subgroupDeleteButton, setSubgroupDeleteButton] = useState("");

  let subgroupRefArray: string[] = [];
  let subgroupTitles: string[] = [];
  let subgroupDescriptions: string[] = [];
  let subgroupDetailedDescriptions: string[] = [];
  let tempSubgroup: NewGroupProfileType;
  let subgroupTitlesIndex = 1;

  const SubgroupSelected = (e: ChangeEvent<HTMLSelectElement>) => {
    subgroupTitlesIndex = parseInt(e.target.value);
    console.log(" project selected is ", subgroupTitlesIndex);
    setSubgroupTitleInput(subgroupTitles[subgroupTitlesIndex]);
    //It makes sense to set up the groupTitles array so that we can do a fetch
    //and retrieve the document from its (group) name or by its reference if we
    //indeed save the reference at the time we do the initial query. Then we
    //can retrieve the document fields of description and detailed description.
    //This same logic can be duplicated for subgroups and projects
    console.log(" project selected is ", subgroupTitlesIndex);
    setSubgroupDescriptionInput(subgroupDescriptions[subgroupTitlesIndex]);
    setSubgroupDetailedDescriptionInput(
      subgroupDetailedDescriptions[subgroupTitlesIndex]
    );
    //localStorage.setItem("projectTitle", projectTitles[groupTitlesIndex]);
    //console.log(
    //  " project selected title is ",
    //  projectTitles[projectTitlesIndex]
    //);
  };

  const q1 = query(
    collection(db, "Groups"),
    where("containedInGroups", "!=", []),
    orderBy("title")
  );
  useEffect(
    () =>
      onSnapshot(q1, (snapshot) => {
        setSubgroupProfiles(
          snapshot.docs.map((doc) => {
            //console.log(" adminInfo 1 doc id = ", doc.id);
            //console.log(" adminInfo 2 projectProfiles = ", projectProfiles);
            tempSubgroup = subgroupProfiles;

            if (doc.id) {
              console.log(" Admin got a doc id from onSnapshot for groups! ");
              subgroupRefArray.push(doc.id);
              console.log(" subgroupRefArray [0] ", subgroupRefArray[0]);
              console.log(" doc data () ", doc.data());
            }
            return {
              id: doc.id,
              ...doc.data(),
            };
            //return {};
          })
        );
      }),
    []
  );

  //The following produces a document snapshot
  //getDoc(doc(getFirestore(), "projectProfiles", "projectTitle")).then(
  //  (projectTitle) => {
  //    console.log("adminInfo projectTitle = ", projectTitle);
  //  }
  //);
  console.log(" before if subgroupProfiles and tempSubgroup = ", tempSubgroup);
  if (subgroupProfiles) {
    //The array of full objects with id as the key
    console.log(" adminInfo subgroupProfiles = ", subgroupProfiles);
    //What we'd like to do here is to create a new array consisting of just
    //The project titles (projectTitle) and that array will provide for the list box
    for (let i = 0; i < subgroupProfiles.length; i++) {
      subgroupTitles[i] = subgroupProfiles[i].title;
      console.log("subgroup titles array [0] = ", subgroupTitles[0]);
    }
  }
  //This is simply an array of doc ids - different from a reference
  if (subgroupRefArray) {
    //The array of doc ids
    console.log(" sub group array ids [0] = ", subgroupRefArray[0]);
  }

  //Project
  const [projectProfiles, setProjectProfiles] = useState<
    NewProjectProfileType[]
  >([]);

  const [projectTitleInput, setProjectTitleInput] = useState("");
  const [projectDescriptionInput, setProjectDescriptionInput] = useState("");
  const [projectDetailedDescriptionInput, setProjectDetailedDescriptionInput] =
    useState("");
  const [projectSaveButton, setProjectSaveButton] = useState("");
  const [projectCreateButton, setProjectCreateButton] = useState("");
  const [projectDeleteButton, setProjectDeleteButton] = useState("");

  let projectRefArray: string[] = [];
  let projectTitles: string[] = [];
  let projectDescriptions: string[] = [];
  let projectDetailedDescriptions: string[] = [];
  let tempProject: NewGroupProfileType;
  let projectTitlesIndex = 1;

  const ProjectSelected = (e: ChangeEvent<HTMLSelectElement>) => {
    projectTitlesIndex = parseInt(e.target.value);
    console.log(" project selected is ", projectTitlesIndex);
    setProjectTitleInput(projectTitles[projectTitlesIndex]);
    //It makes sense to set up the groupTitles array so that we can do a fetch
    //and retrieve the document from its (group) name or by its reference if we
    //indeed save the reference at the time we do the initial query. Then we
    //can retrieve the document fields of description and detailed description.
    //This same logic can be duplicated for subgroups and projects
    console.log(" project selected is ", projectTitlesIndex);
    setProjectDescriptionInput(projectDescriptions[projectTitlesIndex]);
    setProjectDetailedDescriptionInput(
      projectDetailedDescriptions[projectTitlesIndex]
    );
    //localStorage.setItem("projectTitle", projectTitles[groupTitlesIndex]);
    //console.log(
    //  " project selected title is ",
    //  projectTitles[projectTitlesIndex]
    //);
  };
  console.log("tempUser = ", tempUser);
  const q2 = query(
    collection(db, "projectProfiles"),
    where("projectUserMembers", "array-contains", tempUser),
    orderBy("title")
  );
  useEffect(
    () =>
      onSnapshot(q2, (snapshot) => {
        setProjectProfiles(
          snapshot.docs.map((doc) => {
            //console.log(" adminInfo 1 doc id = ", doc.id);
            //console.log(" adminInfo 2 projectProfiles = ", projectProfiles);
            tempProject = projectProfiles;
            console.log("temp");
            if (doc.id) {
              console.log(" Admin got a doc id from onSnapshot for profiles! ");
              projectRefArray.push(doc.id);
              console.log(" projectRefArray [0] ", projectRefArray[0]);
              console.log(" doc data () ", doc.data());
            }
            return {
              id: doc.id,
              ...doc.data(),
            };
            //return {};
          })
        );
      }),
    []
  );

  //The following produces a document snapshot
  //getDoc(doc(getFirestore(), "projectProfiles", "projectTitle")).then(
  //  (projectTitle) => {
  //    console.log("adminInfo projectTitle = ", projectTitle);
  //  }
  //);
  console.log(" before if projectProfiles and tempProject = ", tempProject);
  if (projectProfiles) {
    //The array of full objects with id as the key
    console.log(" adminInfo projectProfiles = ", projectProfiles);
    //What we'd like to do here is to create a new array consisting of just
    //The project titles (projectTitle) and that array will provide for the list box
    for (let i = 0; i < projectProfiles.length; i++) {
      projectTitles[i] = projectProfiles[i].title;
      console.log("project titles array [0] = ", projectTitles[0]);
    }
  }
  //This is simply an array of doc ids - different from a reference
  if (projectRefArray) {
    //The array of doc ids
    console.log(" sub group array ids [0] = ", projectRefArray[0]);
  }

  //Users
  const [userProfiles, setUserProfiles] = useState<NewUserProfileType[]>([]);
  const [userTitleInput, setUserTitleInput] = useState("");
  const [userDescriptionInput, setUserDescriptionInput] = useState("");
  const [userDetailedDescriptionInput, setUserDetailedDescriptionInput] =
    useState("");

  let userRefArray: string[] = [];
  let userTitles: string[] = [];
  let userDescriptions: string[] = [];
  let userDetailedDescriptions: string[] = [];
  let userTitlesIndex = 1;

  let docUserRefArray: string[] = [];
  let userNames: string[] = [];
  let tempUserProfile: NewUserProfileType;
  const UserSelected = (e: ChangeEvent<HTMLSelectElement>) => {
    userTitlesIndex = parseInt(e.target.value);
    console.log(" user selected is ", userTitlesIndex);
    setUserTitleInput(userTitles[userTitlesIndex]);
    //It makes sense to set up the groupTitles array so that we can do a fetch
    //and retrieve the document from its (group) name or by its reference if we
    //indeed save the reference at the time we do the initial query. Then we
    //can retrieve the document fields of description and detailed description.
    //This same logic can be duplicated for subgroups and projects
    console.log(" user selected is ", userTitlesIndex);
    setUserDescriptionInput(userDescriptions[userTitlesIndex]);
    setUserDetailedDescriptionInput(userDetailedDescriptions[userTitlesIndex]);
    //localStorage.setItem("projectTitle", projectTitles[groupTitlesIndex]);
    //console.log(
    //  " project selected title is ",
    //  projectTitles[projectTitlesIndex]
    //);
  };
  const q3 = query(
    collection(db, "userProfiles"),
    where("userProfileName", "!=", ""),
    orderBy("userProfileName")
  );

  useEffect(
    () =>
      onSnapshot(q3, (snapshot) => {
        setUserProfiles(
          snapshot.docs.map((doc) => {
            console.log(" adminInfo 3 user id = ", doc.id);
            console.log(" adminInfo 4 userProfiles = ", userProfiles);
            tempUserProfile = userProfiles;

            if (doc.id) {
              docUserRefArray.push(doc.id);
            }
            return {
              id: doc.id,
              ...doc.data(),
            };
            //return {};
          })
        );
      }),
    []
  );
  console.log("userProfiles = ", userProfiles);
  if (userProfiles) {
    //The array of full objects with id as the key
    console.log(" adminInfo userProfiles = ", userProfiles);
    //What we'd like to do here is to create a new array consisting of just
    //the user names (userPofileName) and that array will provide for the list box
    for (let i = 0; i < userProfiles.length; i++) {
      userNames[i] = userProfiles[i].userProfileName;
    }
    console.log("user names array = ", userNames);
  }
  //This is simply an array of doc ids - different from a reference
  if (docUserRefArray) {
    //The array of doc ids
    console.log(" user array = ", docUserRefArray);
  }

  const projectTitlesLength = projectTitles.length;
  const userNamesLength = userNames.length;
  return (
    <>
      <div>
        <div className={styles.wrapper}>
          <div className={styles.top}>
            <label
              style={{
                marginLeft: 0,
                fontWeight: 550,
                fontSize: 25,
                marginTop: 0,
              }}
            >
              Administration - My Groups
            </label>

            <label
              className={styles.forh3}
              style={{
                marginLeft: 270,
                fontWeight: 500,
                fontSize: 18,
                marginRight: 10,
                marginTop: 5,
              }}
            >
              Users
            </label>
            <select
              name="User List"
              id="user-select"
              onChange={UserSelected}
              style={{
                marginLeft: 30,
                height: 18,
                marginTop: 7,
              }}
            >
              <option value="">-- User Selections --</option>
              {userNames.map((userNames, key) => (
                <option key={key} value={userNames}>
                  {userNames}
                </option>
              ))}
            </select>
          </div>
          <br />
          <div>
            <label
              className={styles.forh3}
              style={{ marginLeft: 25, fontWeight: 550, fontSize: 20 }}
            >
              Groups
            </label>
            <select
              name="Group List"
              id="group-select"
              onChange={GroupSelected}
              style={{ marginLeft: 50 }}
            >
              <option value="">-- Group Selections --</option>
              {groupTitles.map((groupTitles, key) => (
                <option key={key} value={groupTitles}>
                  {groupTitles}
                </option>
              ))}
            </select>
            <a href="#">
              <button
                className={styles.buttonClass}
                style={{ marginLeft: 425, marginTop: -27 }}
              >
                {groupSaveButton}
              </button>
            </a>
            <a href="#">
              <button
                className={styles.buttonClass}
                style={{ marginLeft: 575, marginTop: -40 }}
              >
                {groupCreateButton}
              </button>
            </a>
            <a href="#">
              <button
                className={styles.buttonClass}
                style={{ marginLeft: 725, marginTop: -49 }}
              >
                {groupDeleteButton}
              </button>
            </a>
          </div>

          <div className={styles.aimLabel}>
            <label style={{ marginLeft: 30, marginTop: 5 }}>Group Title</label>
            <textarea
              className={styles.messageText}
              rows={3}
              cols={80}
              style={{
                paddingLeft: 3,
                marginLeft: 50,
                width: 460,
                height: 25,
                marginTop: 3,
              }}
              defaultValue={groupTitleInput}
              onChange={(e) => {
                setGroupTitleInput(e.target.value);
              }}
            />
            <br />
          </div>

          <div className={styles.aimLabel}>
            <label style={{ marginLeft: 30 }}>Group Description</label>
            <textarea
              className={styles.messageText}
              rows={3}
              cols={80}
              style={{ paddingLeft: 3, marginLeft: 50, width: 460, height: 50 }}
              defaultValue={groupDescriptionInput}
              onChange={(e) => {
                setGroupDescriptionInput(e.target.value);
              }}
            />
          </div>

          <div className={styles.aimLabel}>
            <label style={{ marginLeft: 30 }}>Group Detailed Description</label>
            <textarea
              className={styles.messageText}
              rows={3}
              cols={80}
              style={{ paddingLeft: 3, marginLeft: 50, width: 460, height: 75 }}
              defaultValue={groupDetailedDescriptionInput}
              onChange={(e) => {
                setGroupDetailedDescriptionInput(e.target.value);
              }}
            />
          </div>
          <br />
        </div>
      </div>
    </>
  );
}

export default AdminInformation;
